module.exports = __webpack_public_path__ + "bot-icon.png?b545f7757656424f7eab721121804b5c";